// frontend/src/pages/instalacion.jsx
import React, { useState, useEffect } from "react";
import axios from "../api/axios";
import { useNavigate, Link } from "react-router-dom";
import { getRoute } from "../utils/routes";
import { useAuth } from "../context/AuthContext";
import { RiEyeLine } from "react-icons/ri";

function Instalacion() {
  const [instalaciones, setInstalaciones] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { user } = useAuth();

  //Obtener rol real
  const userRole = user?.role || "";

  useEffect(() => {
    const fetchInstalaciones = async () => {
      try {
        const { data } = await axios.get("/api/instalacion");
        setInstalaciones(data);
      } catch (error) {
        console.error("Error cargando instalaciones:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchInstalaciones();
  }, []);

    
  const handleNavigate = () => {
    const allowedRoles = ["admin", "user"];
    if (allowedRoles.includes(userRole)) {
      const route = getRoute(user, `addInstal`);
      navigate(route);
    } else {
      alert("No tienes permisos para añadir instalaciones");
     }
  };

  return (
    <div className="px-4 min-h-[calc(100vh-6rem)]">
      <h1 className="p-3 px-5 font-bold small-2xl uppercase">instalaciones</h1>	
      <button
        onClick={handleNavigate}
        disabled={!["admin", "user"].includes(userRole)}
        className={`px-4 py-2 rounded mb-3 ${
        ["admin", "user"].includes(userRole)
        ? "bg-secondary-900 text-white hover:text-blue-100"
        : "bg-gray-400 cursor-not-allowed"
      }`}
      >
      Añadir Instalación
      </button>

      {/* Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
        {loading ? (
          <p>Cargando instalaciones...</p>
        ) : instalaciones.length === 0 ? (
          <p>No hay instalaciones registradas.</p>
        ) : (
          instalaciones.map((instal) => (
            <div
              key={instal.id}
              className="flex flex-col justify-between bg-secondary-900 p-4 rounded-xl h-[300px] overflow-hidden"
            >
              <div>
                <div className="flex justify-between items-center font-bold text-mid uppercase mb-2">
                  <span>Cliente: {instal.nombre}</span>
                  <div className="flex gap-2">
                    <Link
                      to={getRoute(user, `viewInstall/${instal.id}`)}
                      className="flex items-center me-5"
                    >
                      <RiEyeLine size={20} />
                    </Link>
                  </div>
                </div>
                <h1 className="font-bold text-mid uppercase mb-2">
                  Dirección: {instal.direccion}
                </h1>
                <h1 className="font-bold text-mid uppercase mb-2">
                  Población: {instal.poblacion}
                </h1>
                <h1 className="font-bold text-mid uppercase mb-2">
                  Tel: {instal.telefono}
                </h1>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default Instalacion;
